import React from "react";
import Header from "../common/Header";
import Aside from "../common/Asside";

function Material() {
    
  return (
    <div>
      <Header />
      <div className="container-flex">
        <Aside />
        <div className="main">
          <div className="page-content">
            <div className="main-inner">
                <div className="page-content-body" style={{display: 'block'}}>
                    <form action="#" id="affiliateLinkForm" noValidate="novalidate">
                    <div className="section">
                        <div className="section-head">
                        <h2 className="title">Links</h2>
                        </div>
                        <div className="section-body">
                        <div className="table-wrap">
                            <div id="affiliateLinkTable_wrapper" className="dataTables_wrapper no-footer">
                            <div className="dt-buttons">
                                <button className="dt-button buttons-collection buttons-colvis" tabIndex={0} aria-controls="affiliateLinkTable" type="button" aria-haspopup="true" aria-expanded="false"><span>Column visibility</span></button>
                            </div>
                            <table id="affiliateLinkTable" className="table dataTable no-footer" role="grid" aria-describedby="affiliateLinkTable_info">
                                <thead>
                                <tr role="row">
                                    <th className="sorting_asc" rowSpan={1} colSpan={1} aria-label="#">#</th>
                                    <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Domain">Domain</th>
                                    <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Status">Status</th>
                                    <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Keywords">Keywords</th>
                                    <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Page">Page</th>
                                    <th className="sorting_disabled" rowSpan={1} colSpan={1} aria-label="Action">Action</th>
                                </tr>
                                </thead>
                               
                            </table>
                           
                            
                           
                            </div>
                        </div>
                        </div>
                        <div className="section-foot">
                        <button type="button" className="btn-primary float-right reload-data">Search</button>
                        <button type="button" className="btn-primary float-right" id="createBtn">Create</button>
                        </div>
                    </div>
                    </form>
                    <template id="affiliateLinkModalBody" />
                </div>
            </div>



            <footer className="footer">
              Copyright © 2020. All rights Reserved
            </footer>
            {/* Modal Backdrop */}
            
          </div>
        </div>
      </div>
    </div>
  );
}
export default Material;
